export default __webpack_public_path__ + "static/media/gallery_02.174ff995.jpg";